<template>
  <div>
    <div class="d-flex w-100 justify-content-between align-items-center p-3 menu-entry" @click="onEntrySelected(entry)">
      <i :class="[entry.icon, 'icon-size-md', 'font-color-primary']" />
      <span class="font-weight-bold">{{ $t(entry.translationKey) }}</span>
    </div>
    <div class="w-100 d-flex justify-content-end">
      <div
        v-for="subItem in subItems"
        :key="subItem.id"
        class="p-3 mx-2 d-flex w-100 justify-content-between align-items-center menu-entry small"
        @click="onEntrySelected(subItem)"
      >
        <i :class="[subItem.icon, 'icon-size-md', 'font-color-primary']" />
        <span class="font-weight-bold">{{ $tc(subItem.translationKey, 2) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../event-bus.js';
export default {
  name: 'MenuEntry',
  components: {},
  props: {
    entry: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    subItems() {
      return this.entry.subItems || [];
    },
    isActive() {
      let isSubRoute = this.entry.subItems.filter((el) => el.routeName === this.$route.name).length > 0;
      return this.entry.routeName === this.$route.name || isSubRoute;
    },
  },
  methods: {
    onEntrySelected(item) {
      if (item.routeName === this.$route.name) {
        return;
      }
      if (window.innerWidth < 900) EventBus.$emit('sidebarToggle');
      this.$router.push({ name: item.routeName });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/colors';
.menu-entry {
  cursor: pointer;
  border-radius: 1rem;
  transition: all 0.25s ease-in-out;
  &:hover {
    background: #e3e3e3;
  }
}

.small i {
  font-size: 1.1rem;
}
</style>
